import moment from "moment";
import { buildDemoStudentsForClass } from "./buildDemoStudents";
import { DEMO_SCENARIO, DEMO_SCENARIO_CLASS_ID } from "./demoScenario";

/**
 * Status de aula do aluno (demo offline).
 * - previous: última aula encerrada (+ attendance)
 * - current: aula em andamento
 * - next: próxima (mesmo dia ou seguinte)
 */

function formatHm(m) {
  return m.format("HH:mm");
}

function slot({ type, disciplina, sala, start, end, professor, attendance }) {
  return {
    type,
    disciplina,
    turma: DEMO_SCENARIO_CLASS_ID,
    sala,
    professor: professor || "Prof. Demo",
    start: start.toISOString(),
    end: end.toISOString(),
    startLabel: formatHm(start),
    endLabel: formatHm(end),
    dateLabel: start.format("DD/MM"),
    attendance: attendance != null ? attendance : null
  };
}

/**
 * @param {string} studentId RA do aluno
 * @param {moment.Moment} [now]
 * @returns {{ previous: object|null, current: object|null, next: object|null }}
 */
export function buildDemoStudentClassStatus(studentId, now = moment()) {
  const students = buildDemoStudentsForClass(DEMO_SCENARIO_CLASS_ID);
  if (!students.some(x => String(x.ra) === String(studentId))) {
    return { previous: null, current: null, next: null };
  }

  const forceLive = DEMO_SCENARIO.forceLiveClassOnStudentProfile !== false;
  // Alterna presença/falta na demo por RA (demo visual)
  const digits = String(studentId).replace(/\D/g, "");
  const odd = Number(digits.slice(-1) || 0) % 2 === 1;
  const previousAttendance = odd ? "present" : "absent";

  if (forceLive) {
    const previousStart = now.clone().subtract(90, "minutes");
    const previousEnd = now.clone().subtract(40, "minutes");
    const currentStart = now.clone().subtract(20, "minutes");
    const currentEnd = now.clone().add(25, "minutes");
    const nextStart = currentEnd.clone().add(15, "minutes");
    const nextEnd = nextStart.clone().add(50, "minutes");

    return {
      previous: slot({
        type: "PREVIOUS_CLASS",
        disciplina: "História",
        sala: "Sala 10",
        start: previousStart,
        end: previousEnd,
        professor: "Prof. Demo — História",
        attendance: previousAttendance
      }),
      current: slot({
        type: "CURRENT_CLASS",
        disciplina: "Português",
        sala: "Sala 12",
        start: currentStart,
        end: currentEnd,
        professor: "Prof. Demo — Língua Portuguesa"
      }),
      next: slot({
        type: "NEXT_CLASS",
        disciplina: "Matemática",
        sala: "Sala 14",
        start: nextStart,
        end: nextEnd,
        professor: "Prof. Demo — Matemática"
      })
    };
  }

  const previousStart = now.clone().subtract(2, "hours");
  const previousEnd = previousStart.clone().add(50, "minutes");
  const nextStart = now.clone().add(45, "minutes").startOf("minute");
  const nextEnd = nextStart.clone().add(50, "minutes");
  return {
    previous: slot({
      type: "PREVIOUS_CLASS",
      disciplina: "Geografia",
      sala: "Sala 8",
      start: previousStart,
      end: previousEnd,
      attendance: previousAttendance
    }),
    current: null,
    next: slot({
      type: "NEXT_CLASS",
      disciplina: "Ciências",
      sala: "Lab. 2",
      start: nextStart,
      end: nextEnd
    })
  };
}
